import FMP_CONFIG from './fmpConfig';

const configurationData = {
    supported_resolutions: ['1', '3', '5', '15', '30', '60', '120', '240', '360', '480', '720', '1D', '3D', '1W', '1M'],
    exchanges: [{
        value: 'FMP',
        name: 'Financial Modeling Prep',
        desc: 'FMP Enterprise'
    }],
    symbols_types: [{
        name: 'stock',
        value: 'stock'
    }, {
        name: 'commodity',
        value: 'commodity'
    }, {
        name: 'forex',
        value: 'forex'
    }]
};

const DEFAULT_BASE_URL = (FMP_CONFIG.baseUrl || 'https://financialmodelingprep.com/api/v3').replace(/\/$/, '');

// DXTrade WebSocket configuration
const DXTRADE_WS_URL = 'wss://alchemytvstage.prosp.devexperts.com/dxsca-web/md/?format=JSON';

export class FMPDatafeed {
    constructor(options = {}) {
      this.apiKey = options.apiKey;
      this.subscribers = {};
      this.requestsPending = 0;
      this.historyLimit = options.limit || 1000;
      this.assetType = (options.type || 'STOCK').toUpperCase();
      this.symbolMetadata = new Map();
      this.lastBarsCache = new Map();
      this.historyCache = new Map(); // Cache to prevent duplicate requests
      
      // DXTrade user credentials (passed from chart page)
      this.dxUsername = options.dxUsername;
      this.dxPassword = options.dxPassword;
      this.dxClearingCode = options.dxClearingCode;
      this.dxSessionToken = options.dxSessionToken;

      // DXTrade WebSocket management
      this.dxWebSocket = null;
      this.dxReconnectAttempts = 0;
      this.dxMaxReconnectAttempts = 5;
      this.dxReconnectDelay = 5000;
      this.dxSubscriptions = new Map();
      this.dxWebSocketReady = false;
      this.dxPendingSubscriptions = [];
    }

    onReady(callback) {
      setTimeout(() => callback(configurationData));
    }

    async searchSymbols(userInput, exchange, symbolType, onResultReadyCallback) {
      console.log('searchSymbols', userInput, exchange, symbolType);
      try {
        const response = await fetch(`${DEFAULT_BASE_URL}/search?query=${userInput}&limit=10&apikey=${this.apiKey}`);
        const data = await response.json();
        
        const symbols = data.map(item => ({
          symbol: item.symbol,
          full_name: item.symbol,
          description: `${item.symbol} - ${item.name}`,
          exchange: item.exchangeShortName || item.exchange,
          type: (item.type || 'stock').toLowerCase(),
        }));
        
        onResultReadyCallback(symbols);
      } catch (error) {
        console.error('Error searching symbols:', error);
        onResultReadyCallback([]);
      }
    }

    async resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
      try {
        const response = await fetch(`${DEFAULT_BASE_URL}/quote?symbol=${symbolName}&apikey=${this.apiKey}`);
        const data = await response.json();
        
        if (!data || data.length === 0) {
          throw new Error('Symbol not found');
        }
        
        let symboldata = data[0];
        
        let pricescale = 100;
        if (symboldata.price) {
          if (symboldata.price < 1) {
            pricescale = 10000;
          } else if (symboldata.price < 10) {
            pricescale = 1000;
          } else {
            pricescale = 100;
          }
        }
        
        const symbolInfo = {
            name: symboldata.symbol,
            description: symboldata.companyName || symboldata.symbol,
            type: this.assetType.toLowerCase(),
            session: this.assetType === 'STOCK' ? '0930-1600' : '24x7',
            timezone: this.assetType === 'STOCK' ? 'America/New_York' : 'Etc/UTC',
            exchange: symboldata.exchangeShortName || symboldata.exchange,
            minmov: 1,
            pricescale: pricescale,
            has_intraday: true,
            has_daily: true,
            has_weekly_and_monthly: true,
            supported_resolutions: configurationData.supported_resolutions,
            volume_precision: 0,
            data_status: 'streaming',
        };

        onSymbolResolvedCallback(symbolInfo);
      } catch (error) {
        console.error('Error resolving symbol:', error);
        onResolveErrorCallback('Error resolving symbol');
      }
    }

    // async getBars(symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) {
    //   const { from, to, firstDataRequest } = periodParams;

    //   try {

    //     const interval = mapResolutionToFmp(resolution);
    //     if (!interval) {
    //       throw new Error(`Unsupported resolution: ${resolution}`);
    //     }

    //     const fromDate = toDateYMD(from);
    //     const toDate = toDateYMD(to);

    //     const params = new URLSearchParams({
    //       symbol: symbolInfo.name,
    //       apikey: this.apiKey,
    //     });

    //     if (!firstDataRequest && fromDate) {
    //       params.append('from', fromDate);
    //     }
    //     if (!firstDataRequest && toDate) {
    //       params.append('to', toDate);
    //     }

    //     let response;
    //     if (interval === '1day') {
    //       response = await fetch(`${DEFAULT_BASE_URL}/historical-price-eod/full?${params.toString()}`);
    //     } else {
    //       response = await fetch(`${DEFAULT_BASE_URL}/historical-chart/${interval}?${params.toString()}`);
    //     }
        
    //     if (!response.ok) {
    //       throw new Error(`HTTP error! status: ${response.status}`);
    //     }

    //     let data = await response.json();
        
    //     // Handle different response formats
    //     if (interval === '1day' && data.historical) {
    //       data = data.historical;
    //     }
        
    //     console.log(`[getBars]: Fetched ${data?.length || 0} entries from FMP`);
        
    //     if (!Array.isArray(data) || data.length === 0) {
    //       console.log('[getBars]: No data returned');
    //       const meta = { noData: true };
    //       onHistoryCallback([], meta);
    //       return;
    //     }
        
    //     const bars = data
    //       .map((source) => {
    //         return {
    //           time: parseTime(source.date),
    //           open: parseFloat(source.open),
    //           high: parseFloat(source.high),
    //           low: parseFloat(source.low),
    //           close: parseFloat(source.close),
    //           volume: parseFloat(source.volume ?? 0),
    //         };
    //       })
    //       .filter((bar) => {
    //         const isValid = Number.isFinite(bar.time);
            
    //         // On first request, don't filter by time range - return all valid bars
    //         if (firstDataRequest) {
    //           return isValid;
    //         }
            
    //         // On subsequent requests (scrolling back), filter by time range
    //         const isInRange = bar.time >= from * 1000 && bar.time <= to * 1000;
    //         return isValid && isInRange;
    //       })
    //       .sort((a, b) => a.time - b.time);

    //     if (bars.length === 0) {
    //       console.log('[getBars]: No bars after filtering');
    //       const meta = { noData: true };
    //       onHistoryCallback([], meta);
    //       return;
    //     }

    //     // Update cache
    //     const cacheKeySymbol = `${symbolInfo.name}_${resolution}`;
    //     this.lastBarsCache.set(cacheKeySymbol, bars[bars.length - 1]);

    //     console.log(`[getBars]: Returning ${bars.length} bars, range: ${new Date(bars[0].time).toISOString()} to ${new Date(bars[bars.length - 1].time).toISOString()}`);
        
    //     // Determine if there's more historical data available
    //     // If we got very few bars or hit the beginning of available data, tell TradingView
    //     const meta = {
    //       noData: false,
    //       nextTime: bars.length < 50 ? undefined : bars[0].time / 1000
    //     };
        
    //     onHistoryCallback(bars, meta);
        
    //   } catch (error) {
    //     console.error('[getBars]: Error:', error);
    //     onErrorCallback(error.message || 'Error getting bars');
    //   }
    // }
    
    async getBars(symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) {
      const { from, to, firstDataRequest } = periodParams;

      // Create cache key to prevent duplicate requests
      const cacheKey = `${symbolInfo.name}_${resolution}_${from}_${to}_${firstDataRequest}`;
      
      // Check if request is already in progress
      if (this.historyCache.has(cacheKey)) {
        const cachedData = this.historyCache.get(cacheKey);
        if (cachedData.pending) {
          // Wait for the pending request
          return cachedData.promise;
        }
        // Return cached result if available and recent (within 30 seconds)
        if (cachedData.timestamp && (Date.now() - cachedData.timestamp < 30000)) {
          onHistoryCallback(cachedData.bars, cachedData.meta);
          return;
        }
      }

      // Create promise for this request
      const requestPromise = (async () => {
        try {
          const interval = mapResolutionToFmp(resolution);
          if (!interval) {
            throw new Error(`Unsupported resolution: ${resolution}`);
          }

          const fromDate = toDateYMD(from);
          const toDate = toDateYMD(to);

          const params = new URLSearchParams({
            symbol: symbolInfo.name,
            apikey: this.apiKey,
          });

          if (!firstDataRequest && fromDate) {
            params.append('from', fromDate);
          }
          if (!firstDataRequest && toDate) {
            params.append('to', toDate);
          }

          let response;
          if (interval === '1day') {
            response = await fetch(`${DEFAULT_BASE_URL}/historical-price-eod/full?${params.toString()}`);
          } else {
            response = await fetch(`${DEFAULT_BASE_URL}/historical-chart/${interval}?${params.toString()}`);
          }
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          let data = await response.json();
          
          if (interval === '1day' && data.historical) {
            data = data.historical;
          }
          
          if (!Array.isArray(data) || data.length === 0) {
            const meta = { noData: true };
            this.historyCache.set(cacheKey, { bars: [], meta, timestamp: Date.now(), pending: false });
            onHistoryCallback([], meta);
            return;
          }
          
          const bars = data
            .map((source) => {
              return {
                time: parseTime(source.date),
                open: parseFloat(source.open),
                high: parseFloat(source.high),
                low: parseFloat(source.low),
                close: parseFloat(source.close),
                volume: parseFloat(source.volume ?? 0),
              };
            })
            .filter((bar) => {
              const isValid = Number.isFinite(bar.time);
              if (firstDataRequest) {
                return isValid;
              }
              const isInRange = bar.time >= from * 1000 && bar.time <= to * 1000;
              return isValid && isInRange;
            })
            .sort((a, b) => a.time - b.time);

          if (bars.length === 0) {
            const meta = { noData: true };
            this.historyCache.set(cacheKey, { bars: [], meta, timestamp: Date.now(), pending: false });
            onHistoryCallback([], meta);
            return;
          }

          const cacheKeySymbol = `${symbolInfo.name}_${resolution}`;
          this.lastBarsCache.set(cacheKeySymbol, bars[bars.length - 1]);

          const meta = {
            noData: false,
            nextTime: bars.length < 50 ? undefined : bars[0].time / 1000
          };
          
          // Cache the result
          this.historyCache.set(cacheKey, { bars, meta, timestamp: Date.now(), pending: false });
          onHistoryCallback(bars, meta);
          
        } catch (error) {
          console.error('[getBars]: Error:', error);
          this.historyCache.delete(cacheKey);
          onErrorCallback(error.message || 'Error getting bars');
        }
      })();

      // Mark as pending
      this.historyCache.set(cacheKey, { promise: requestPromise, pending: true });
      await requestPromise;
    }

    // Initialize DXTrade WebSocket connection
    async initializeDXWebSocket() {
      if (this.dxWebSocket && this.dxWebSocket.readyState === WebSocket.OPEN) {
        console.log('[DXTrade]: WebSocket already connected');
        return true;
      }

      if (!this.dxUsername || !this.dxPassword || !this.dxClearingCode) {
        console.warn('[DXTrade]: WebSocket not initialized - credentials not provided.');
        return false;
      }

      return new Promise((resolve, reject) => {
        try {
          console.log('[DXTrade]: Initializing WebSocket connection');
          
          this.dxWebSocket = new WebSocket(DXTRADE_WS_URL);
          
          const connectionTimeout = setTimeout(() => {
            console.error('[DXTrade]: Connection timeout');
            if (this.dxWebSocket) {
              this.dxWebSocket.close();
            }
            reject(new Error('WebSocket connection timeout'));
          }, 10000);

          this.dxWebSocket.onopen = async () => {
            clearTimeout(connectionTimeout);
            console.log('[DXTrade]: WebSocket connected, attempting authentication...');
            
            try {
              const sessionToken = await this.dxTradeLogin();
              
              if (!sessionToken) {
                throw new Error('Failed to authenticate with DXTrade');
              }
              
              this.dxWebSocketReady = true;
              this.dxReconnectAttempts = 0;
              
              console.log('[DXTrade]: Authentication successful');
              
              this.processPendingSubscriptions();
              
              resolve(true);
            } catch (error) {
              console.error('[DXTrade]: Authentication error:', error);
              if (this.dxWebSocket) {
                this.dxWebSocket.close();
              }
              reject(error);
            }
          };

          this.dxWebSocket.onmessage = (event) => {
            this.handleDXMessage(event.data);
          };

          this.dxWebSocket.onerror = (error) => {
            console.error('[DXTrade]: WebSocket error:', error);
            clearTimeout(connectionTimeout);
          };

          this.dxWebSocket.onclose = (event) => {
            console.log('[DXTrade]: WebSocket closed', {
              code: event.code,
              reason: event.reason,
              wasClean: event.wasClean
            });
            this.dxWebSocketReady = false;
            
            if (!event.wasClean) {
              this.handleDXReconnect();
            }
          };

        } catch (error) {
          console.error('[DXTrade]: Error initializing WebSocket:', error);
          reject(error);
        }
      });
    }

    async dxTradeLogin() {
      console.log("Initialized the session token:", this.dxSessionToken);
      return this.dxSessionToken;
    }

    handleDXReconnect() {
      if (this.dxReconnectAttempts >= this.dxMaxReconnectAttempts) {
        console.error('[DXTrade]: Max reconnection attempts reached');
        return;
      }

      this.dxReconnectAttempts++;
      const delay = this.dxReconnectDelay * this.dxReconnectAttempts;
      
      console.log(`[DXTrade]: Reconnecting in ${delay}ms (attempt ${this.dxReconnectAttempts}/${this.dxMaxReconnectAttempts})`);
      
      setTimeout(() => {
        this.initializeDXWebSocket().catch((error) => {
          console.error('[DXTrade]: Reconnection failed:', error);
        });
      }, delay);
    }

    processPendingSubscriptions() {
      console.log(`[DXTrade]: Processing ${this.dxPendingSubscriptions.length} pending subscriptions`);
      
      while (this.dxPendingSubscriptions.length > 0) {
        const subscription = this.dxPendingSubscriptions.shift();
        this.sendDXSubscription(
          subscription.symbolInfo,
          subscription.resolution,
          subscription.subscriberUID
        );
      }
    }

    sendDXSubscription(symbolInfo, resolution, subscriberUID) {
      if (!this.dxWebSocketReady || !this.dxWebSocket || this.dxWebSocket.readyState !== WebSocket.OPEN) {
        console.log('[DXTrade]: WebSocket not ready, queuing subscription');
        this.dxPendingSubscriptions.push({ symbolInfo, resolution, subscriberUID });
        return;
      }

      const interval = mapResolutionToDXTrade(resolution);
      const requestId = `CANDLE_${symbolInfo.name}_${resolution}_${Date.now()}`;
      
      const subscriptionRequest = {
          type: "MarketDataSubscriptionRequest",
          requestId: requestId,
          session: this.dxSessionToken,
          payload: {
              account: `${this.dxClearingCode}:${this.dxUsername}`,
              symbols: [ `${symbolInfo.name}.X` ],
              eventTypes: [
                  {
                      type: "Candle",
                      candleType: interval,
                      format: "COMPACT",
                      "fromTime": new Date().toISOString(),
                      // "toTime": "2025-11-13T14:01:06.910Z"
                  }
              ]
          }
      }

      console.log(`[DXTrade]: Subscribing to ${symbolInfo.name} ${resolution}`, subscriptionRequest);
      
      try {
        this.dxWebSocket.send(JSON.stringify(subscriptionRequest));
        
        this.dxSubscriptions.set(subscriberUID, {
          symbolInfo,
          resolution,
          requestId,
          symbol: symbolInfo.name,
          period: interval
        });
        
      } catch (error) {
        console.error('[DXTrade]: Error sending subscription:', error);
      }
    }

    handleDXMessage(message) {
      try {
        const response = JSON.parse(message);
        if (response.type === 'MarketDataSubscriptionResponse') {
          console.log('[DXTrade]: Subscription response:', response);
          
          if (response.payload && response.payload.status === 'SUBSCRIBED') {
            console.log('[DXTrade]: Successfully subscribed to market data');
          }
        }
        else if (response.type === 'MarketData') {
          this.handleMarketDataUpdate(response);
        }
        else if (response.type === 'Error') {
          console.error('[DXTrade]: Error response:', response);
        }
        else {
          // console.log('[DXTrade]: Unknown message type:', response.type);
        }
        
      } catch (error) {
        console.error('[DXTrade]: Error parsing message:', error, message);
      }
    }

    handleMarketDataUpdate(response) {
      try {
        if (!response.payload || !response.payload.events) {
          return;
        }

        const updates = response.payload.events;
        for (const update of updates) {
          if (update.type === 'Candle') {
            // const candle = update;
            for (const [subscriberUID, subscription] of this.dxSubscriptions.entries()) {
              // console.error('[DXTrade]: Market data update received:', update);
              if (subscription.symbol === update.symbol.replace('.X', '') && update.open !== null) {
                
                const bar = {
                  time: parseTime(update.time),
                  open: parseFloat(update.open),
                  high: parseFloat(update.high),
                  low: parseFloat(update.low),
                  close: parseFloat(update.close),
                  volume: parseFloat(update.volume || 0)
                };

                const cacheKey = `${subscription.symbolInfo.name}_${subscription.resolution}`;
                this.lastBarsCache.set(cacheKey, bar);

                if (this.subscribers[subscriberUID]) {
                  this.subscribers[subscriberUID].callback(bar);
                }
                
                // console.error(`[DXTrade]: Updated bar for ${subscription.symbol}:`, bar);
              }
            }
          }
        }
        
      } catch (error) {
        console.error('[DXTrade]: Error handling market data update:', error);
      }
    }

    async subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) {
        console.log(`[subscribeBars]: ${symbolInfo.name} ${resolution} ${subscriberUID}`);
        
        try {
          if (!this.dxWebSocketReady && this.dxSessionToken) {
            await this.initializeDXWebSocket();
          }

          this.subscribers[subscriberUID] = {
            symbolInfo,
            resolution,
            callback: onRealtimeCallback,
            onResetCacheNeeded: onResetCacheNeededCallback
          };

          if (this.dxWebSocketReady) {
            this.sendDXSubscription(symbolInfo, resolution, subscriberUID);
          }
          
        } catch (error) {
          console.error(`[subscribeBars]: Error subscribing to ${symbolInfo.name}:`, error);
        }
    }

    unsubscribeBars(subscriberUID) {
      console.log(`[unsubscribeBars]: ${subscriberUID}`);
      
      const subscription = this.dxSubscriptions.get(subscriberUID);
      
      if (subscription) {
        if (this.dxWebSocketReady && this.dxWebSocket && this.dxWebSocket.readyState === WebSocket.OPEN) {
          // const unsubscribeRequest = {
          //   "type": "MarketDataCloseSubscriptionRequest",
          //   "requestId": `UNSUBSCRIBE_${Date.now()}`,
          //   "refRequestId": this.dxSubscriptions.get(subscriberUID).requestId,
          //   "session": this.dxSessionToken,
          // }
          // console.log(`[DXTrade]: Unsubscribing from ${subscription.symbol}`, unsubscribeRequest);
          
          // try {
          //   this.dxWebSocket.send(JSON.stringify(unsubscribeRequest));
          // } catch (error) {
          //   console.error('[DXTrade]: Error sending unsubscribe request:', error);
          // }
        }
        
        this.dxSubscriptions.delete(subscriberUID);
      }
      
      if (this.subscribers[subscriberUID]) {
        if (this.subscribers[subscriberUID].timer) {
          clearInterval(this.subscribers[subscriberUID].timer);
        }
        
        delete this.subscribers[subscriberUID];
      }
    }

    destroy() {
      console.log('[FMPDatafeed]: Destroying datafeed');
      
      for (const subscriberUID of Object.keys(this.subscribers)) {
        this.unsubscribeBars(subscriberUID);
      }
      
      if (this.dxWebSocket) {
        this.dxWebSocket.close();
        this.dxWebSocket = null;
      }
      
      this.lastBarsCache.clear();
      this.historyCache.clear();
      this.dxSubscriptions.clear();
      this.subscribers = {};
    }
}

function mapResolutionToFmp(resolution) {
  switch (resolution) {
    case '1': return '1min';
    case '5': return '5min';
    case '15': return '15min';
    case '30': return '30min';
    case '60': return '1hour';
    case '1D': return '1day';
    default: return '1min';
  }
}

function mapResolutionToDXTrade(resolution) {
  switch (resolution) {
    case '1': return '1m';
    case '3': return '3m';
    case '5': return '5m';
    case '15': return '15m';
    case '30': return '30m';
    case '60': return '1h';
    case '120': return '2h';
    case '240': return '4h';
    case '360': return '6h';
    case '480': return '8h';
    case '720': return '12h';
    case '1D': return '1d';
    case '3D': return '3d';
    case '1W': return '1w';
    case '1M': return '1M';
    default: return '1m';
  }
}

const parseTime = (value) => {
  if (!value) return NaN;

  if (typeof value === 'number') return value * 1000;

  if (value.includes('T')) {
    const t = Date.parse(value);
    return Number.isFinite(t) ? t : NaN;
  }

  const parts = value.split(/[- :]/);
  if (parts.length >= 6) {
    const [year, month, day, hour, minute, second] = parts.map(Number);
    const utcMillis = Date.UTC(year, month - 1, day, hour + 5, minute, second);
    return utcMillis;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split('-').map(Number);
    return Date.UTC(y, m - 1, d, 0, 0, 0);
  }

  return NaN;
};

const toDateYMD = (ts) => {
  if (ts === undefined || ts === null) {
    return undefined;
  }
  const date = new Date(ts * 1000);
  if (!Number.isFinite(date.getTime())) {
    return undefined;
  }
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};